const AUTOMOD_IDENTIFIERS = ['automoderation@discord.playcdu.internal', 'AutoMod'];

/** creator_id on Staff Manager Notes the backend writes itself (automatic ticket-MVP commendations). */
export const STEWARD_BOT_CREATOR_ID = 'steward@discord.playcdu.internal';

export function isAutoModeration(creatorId: string): boolean {
  return AUTOMOD_IDENTIFIERS.includes(creatorId);
}

export function isStewardBot(creatorId: string): boolean {
  return creatorId === STEWARD_BOT_CREATOR_ID;
}

export function filterAutoModEntries<T extends { creator_id: string }>(
  entries: T[],
  showAutoMod: boolean,
): T[] {
  if (showAutoMod) return entries;
  return entries.filter((entry) => !isAutoModeration(entry.creator_id));
}

export function countAutoModEntries<T extends { creator_id: string }>(entries: T[]): number {
  return entries.filter((entry) => isAutoModeration(entry.creator_id)).length;
}
